import React, { useCallback } from "react";
import PropTypes from "prop-types";
import GenericMasonry from "src/components/GenericMasonry";
import { useSearchOrgImages } from "src/hooks/orgImages";

const CompanyImagesTab = ({
  onSelect,
  leadingItems = [],
  onClickLeadingItems,
  avatarMode = false,
}) => {
  const { searchOrgImages } = useSearchOrgImages();

  const normalizeItem = useCallback((item) => {
    return {
      id: item.id,
      src: item.url,
      alt: item.name,
      width: item.width,
      height: item.height,
      data: item,
    };
  }, []);

  const fetchItems = useCallback(
    async (page, limit, searchTerm) => {
      const result = await searchOrgImages({
        searchTerm,
        offset: page * limit,
        limit,
        generateUrls: true,
      });

      return {
        data: result.images.map(normalizeItem),
        error: null,
        hasMore: result.hasMore,
      };
    },
    [searchOrgImages, normalizeItem]
  );

  return (
    <GenericMasonry
      onSelectionChange={onSelect}
      fetchItems={fetchItems}
      leadingItems={leadingItems}
      onClickLeadingItems={onClickLeadingItems}
      avatarMode={avatarMode}
    />
  );
};

CompanyImagesTab.propTypes = {
  onSelect: PropTypes.func.isRequired,
  leadingItems: PropTypes.arrayOf(PropTypes.object),
  onClickLeadingItems: PropTypes.func,
  avatarMode: PropTypes.bool,
};

export default CompanyImagesTab;
